export default '<span>FavBet koristi kolačiće kako bi osigurao najbolje korisničko iskustvo na našim stranicama. Korištenjem stranice slažete se s korištenjem kolačića</span>';
